module.exports = __webpack_public_path__ + "media/images/beauty/agathe-7c2086731f2ec6d4b8d5a21861d3dd2f.jpg";